module.exports = __webpack_public_path__ + "img/T2C_rc_13.96d88675.png";